import {faqConstants} from "../../constants";

const initialState ={
    date: [],
    status: [],
    select: [],
    recordItems:[],
    isLoading: false,
    isFailure: false,
}

export default function faq(state = initialState, action){
    switch (action.type){
        /******
         리스트
         *****/
        case faqConstants.LOAD_REQUEST:
            return{
                ...state,
                isLoading: !state.isLoading
            }
        case faqConstants.LOAD_SUCCESS:
            return{
                ...state,
                data: action.response.data.payload
            }
        case faqConstants.LOAD_FAILURE:
            return{
                isLoading: false,
                isFailure: true
            }

        /*******
         선택
          *******/

        case faqConstants.SELECT_REQUEST:

            window.open()

            return{
                ...state,
                isLoading: !state.isLoading,
            }

        /*****
         검색
         *****/

        case faqConstants.SEARCH_REQUEST:

            return{
                ...state,
                schcode: action.response.data.payload,
                isLoading: !state.isLoading,
            }

        case faqConstants.SEARCH_SUCCESS:
            return{
                ...state,
                data: action.response.data.payload
            }

        case faqConstants.SEARCH_FAILURE:
            return {
                isLoading: false,
                isFailure: true,
            }

        default:
            return state
    }
}